module.exports = __webpack_public_path__ + "assets/pdf/Cycle 2 California ZIP Errata_0.79ab4dd8.pdf";